<template>
  <div>
    <Main ref="main" :loading="loading" :disabled="disabled" @reload="getData">
      <div slot="header">
        <div class="d-flex mt-2">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_sku_header_title') || '产品明细列表' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseAmzSku()"
              v-if="!disabled"
            >
              {{ $l('btn_chooseAmzSku') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </div>
    </Main>
    <ChooseAmzRegionFtySku
      :visible.sync="chooseAmzSkuOptions.visible"
      :title="chooseAmzSkuOptions.title"
      :scmCode="scmCode"
      :ecomWarehouseCode="ecomWarehouseCode"
      :amazonStoreRegion="amazonStoreRegion"
      :regionCode="regionCode"
      @confirm="skuConfirm"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseAmzRegionFtySku from '@/views/ecom/components/choose-amz-region-fty-sku'
export default {
  mixins: [BaseTable],
  components: { Main, ChooseAmzRegionFtySku },
  props: {
    disabled: { type: Boolean, default: false },
    amzFtyOutboundCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    scmName: { type: String, default: '' },
    ecomWarehouseCode: { type: String, default: '' },
    shipmentByFactory: { type: String, default: '' },
    amazonStoreRegion: { type: String, default: '' },
    amazonStoreRegionName: { type: String, default: '' },
    regionCode: { type: String, default: '' },
    regionName: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      chooseAmzSkuOptions: {
        visible: false,
        title: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzFtyOutboundCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFtyOutboundDetailListApi({
          amzFtyOutboundCode: this.amzFtyOutboundCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const { data } = res.body
      this.$refs.main.setData(data || [])
    },
    chooseAmzSku() {
      if (!this.amazonStoreRegion) {
        this.$message.warning(this.$l('tips_chooseAmzSku_amazonStoreRegion'))
        return
      }
      if (!this.regionCode) {
        this.$message.warning(this.$l('tips_chooseAmzSku_region'))
        return
      }
      if (!this.scmCode) {
        this.$message.warning(this.$l('tips_chooseAmzSku_Scm'))
        return
      }
      if (!this.ecomWarehouseCode && this.shipmentByFactory === 'N') {
        this.$message.warning(this.$l('tips_chooseAmzSku_ecomWarehouse'))
        return
      }

      const title = [this.amazonStoreRegionName, this.regionName, this.scmName]
        .filter(Boolean)
        .join('-')
      this.chooseAmzSkuOptions = { visible: true, title }
    },
    async skuConfirm(data) {
      if (!data || !data.length) return
      const tableData = await this.getTableData()
      if (tableData && tableData.length) {
        data = data.filter(
          (i) => !tableData.map((j) => j.amzSkuCode).includes(i.amzSkuCode)
        )
      }
      if (!data || !data.length) return
      data = data.map((item) => ({
        ...item,
        amzSkuNo: item.amzSkuNo,
        ncNo: item.ftyNcNo || item.ncNo,
        amzStoreSkuNo: item.storeSkuNo
      }))
      this.$refs.main.insertAt(data)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
</style>
